export default __webpack_public_path__ + "static/media/banner2.0f6a5bc5.png";